module.exports = __webpack_public_path__ + "img/product-2-part-bag-tag.4272cf04.png";